"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    TextArgTypes: ()=>TextArgTypes
});
const index_cjs_namespaceObject = require("../../variants/index.cjs");
const basePaletteVariants_cjs_namespaceObject = require("../../variants/palette/basePaletteVariants.cjs");
const baseTextVariants_cjs_namespaceObject = require("../../variants/text/baseTextVariants.cjs");
const TextArgTypes = {
    textStyle: {
        options: baseTextVariants_cjs_namespaceObject.textStyles,
        control: {
            type: 'select'
        }
    },
    bold: {
        control: {
            type: 'boolean'
        }
    },
    italic: {
        control: {
            type: 'boolean'
        }
    },
    align: {
        options: index_cjs_namespaceObject.textAligns,
        control: {
            type: 'select'
        }
    },
    palette: {
        options: basePaletteVariants_cjs_namespaceObject.paletteFamilies,
        control: {
            type: 'select'
        }
    },
    shade: {
        options: basePaletteVariants_cjs_namespaceObject.paletteShades,
        control: {
            type: 'select'
        }
    },
    underline: {
        options: index_cjs_namespaceObject.textUnderlines,
        control: {
            type: 'inline-radio'
        }
    },
    strikethrough: {
        control: {
            type: 'boolean'
        }
    },
    overflow: {
        options: index_cjs_namespaceObject.textOverflows,
        control: {
            type: 'inline-radio'
        }
    },
    lineClamp: {
        options: index_cjs_namespaceObject.lineClamps,
        control: {
            type: 'inline-radio'
        }
    },
    textWrap: {
        options: index_cjs_namespaceObject.textWraps,
        control: {
            type: 'inline-radio'
        }
    },
    wordBreak: {
        options: index_cjs_namespaceObject.wordBreaks,
        control: {
            type: 'inline-radio'
        }
    }
};
exports.TextArgTypes = __webpack_exports__.TextArgTypes;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "TextArgTypes"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
